import { AnimationEvent } from '@angular/animations';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { matExpansionAnimations } from '../animations/expansion.animations';
import { IPlot } from '../models/plot';
import { DEFAULT_UI_OPTIONS, IUiOptions } from '../models/ui-options';
import { PlotsService } from '../services/plots.service';
import { UiOptionsService } from '../services/ui-options.service';

@Component({
    selector: 'sci-grid',
    templateUrl: './grid.container.html',
    animations: [ matExpansionAnimations.growShrink ]
})
export class GridComponent {
    // Use this to determine which datasets are shown on page load
    defaultDatasets = [ 0 ];
    colorTheme: 'dark' | 'light' = 'light';
    plots$: BehaviorSubject<IPlot[]>;
    uiOptions: IUiOptions = DEFAULT_UI_OPTIONS;
    uiList = new FormControl();
    selectedPreset;
    rows = 1;
    cols = 1;
    windowHeight = 950;
    rowHeight = 800;

    constructor( private _plotsService: PlotsService, private _uiOptionsService: UiOptionsService ) {
        this.plots$ = this._plotsService.getPlots$();

        this.windowHeight = window.innerHeight;
        this.calculateRowHeight();
        fromEvent( window, 'resize').pipe(
            debounceTime( 250 )
        ).subscribe( event => {
            this.windowHeight = event.target['innerHeight'];
            this.calculateRowHeight();
        });

        this._uiOptionsService.getUiOptions$().subscribe( newOptions => {
            this.uiOptions = newOptions;

            // calculate a new grid
            this.rows = newOptions.grid.rows;
            this.cols = newOptions.grid.cols;
            this.calculateRowHeight();
        });
    }

    calculateRowHeight() {
        this.rowHeight = ( this.windowHeight - 150 ) / this.rows;
        this.reflowPlots();
    }

    reflowPlots() {
        this._plotsService.reflowPlots();
    }

    updateGrid( update: { cols: number, rows: number } ) {
        this.cols = update.cols;
        this.rows = update.rows;
        this.calculateRowHeight();
        this.reflowPlots();
    }

    /**
     * Initiates the animation that closes out the plot. The chart animation is triggered when the state changes from "open" to "close".
     * When this occurs, the animation triggers. The animation will then hide the element from the dom.
     */
    closePlot( id: string ) {
        this._plotsService.updatePlot( id, 'state', 'collapsed' );
    }

    /**
     * Removing the element at the same time as we animate it out causes problems where the removal may beat the outbound-animation.
     * Therefore,this function is triggered by a hook into the animation (@plotMovement.done) which is called when the animation terminates.
     */
    destroyPlot( event: AnimationEvent, id: string ) {
        if ( event.toState === 'collapsed' ) {
            this._plotsService.removePlot( id );
        }
    }
}
